import axios, { AxiosRequestHeaders } from "axios";

export const api = axios.create({
  baseURL: `https://ms-auth-production.up.railway.app`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("@Auth:Token") || "";
  config.headers = {
    Authorization: `Bearer ${token}`,
  } as AxiosRequestHeaders;
  return config;
});
